/**
 * 判断是否为 ios 设备
 * @param  {string}  [ua]   userAgent 字符串
 * @return {Boolean}
 */
export function isIOS(ua) {
  ua = ua || navigator.userAgent;
  return /ip(hone|od)|ipad/i.test(ua);
}

/**
 * 判断是否为手机设备
 * @param  {string}  [ua]   userAgent 字符串
 * @return {Boolean}
 */
export function isMobile(ua) {
  ua = ua || navigator.userAgent;
  return !!ua.match(
    // eslint-disable-next-line max-len
    /ip(hone|od)|android.+mobile|windows (ce|phone)|blackberry|bb10|symbian|webos|firefox.+fennec|opera m(ob|in)i|polaris|iemobile|lgtelecom|nokia|sonyericsson|dolfin|uzard|natebrowser|ktf;|skt;/i
  );
}

/**
 * 判断是否为iphone
 * @param  {string}  [ua]   userAgent 字符串
 * @return {Boolean}
 */
export function isIPhone(ua) {
  ua = ua || navigator.userAgent;
  return !!ua.match(/iphone/i);
}

/**
 * 判断是否为iPad
 * @param  {string}  [ua]   userAgent 字符串
 * @return {Boolean}
 */
export function isIPad(ua) {
  ua = ua || navigator.userAgent;
  return !!ua.match(/ipad/i);
}

/**
 * 判断是否为 android 设备, iOS jdapp内的webview有'android'字样
 * @param  {string}  [ua]   userAgent 字符串
 * @return {Boolean}
 */
export function isAndroid(ua) {
  ua = ua || navigator.userAgent;
  return /android/i.test(ua) && !isIOS();
}

/**
 * 判断是否为平板设备
 * @param  {string}  [ua]   userAgent 字符串
 * @return {Boolean}
 */
export function isTablet(ua) {
  ua = ua || navigator.userAgent;
  return /ipad/i.test(ua) || (/android/i.test(ua) && !/mobi|mini|fennec/i.test(ua));
}
